<div class="flex justify-around content-center items-center flex-row flex-wrap">
  <div *ngIf="isNotFound" class="basis-full">
    <p>No Report Found</p>
  </div>
  <div id="divshow" [hidden]="isNotFound" class="basis-full">
    <app-card backLink="/reportsubscription" [options]="options" [selectedIndex]="selectedIndex">
      <div #pbiContainer class="pbiContainer"></div>
    </app-card>
  </div>
</div>